__turbopack_context__.v({
  "actions": "WarningModal-module__aGz81a__actions",
  "bottomButton": "WarningModal-module__aGz81a__bottomButton",
  "description": "WarningModal-module__aGz81a__description",
  "icon": "WarningModal-module__aGz81a__icon",
  "link": "WarningModal-module__aGz81a__link",
  "root": "WarningModal-module__aGz81a__root",
  "title": "WarningModal-module__aGz81a__title",
  "topButton": "WarningModal-module__aGz81a__topButton",
});
